import Vue from "vue";
import VueRouter from "vue-router";

import DefaultLayout from "@/layouts/DefaultLayout.vue";
import DefaultNavbarLogin from "@/layouts/DefaultLogin.vue";
import BlankLayout from "@/layouts/BlankLayout.vue";
import DefaultAdmin from "@/layouts/DefaultAdmin.vue";
import DefaultSeller from "@/layouts/DefaultSeller.vue";
import DefaultRider from "@/layouts/DefaultRider.vue";
import DefaultAdminLogin from "@/layouts/DefaultAdminLogin.vue";
import PageNotFound from "@/views/PageNotFound.vue";

import Login from "@/views/Login.vue";
import Home from "@/views/Home.vue";
import Board from "@/views/Board.vue";
import BoardList from "@/views/BoardList.vue";
import BoardDetail from "@/views/BoardDetail.vue";
import Delivery from "@/views/Delivery.vue";
import AboutUS from "@/views/AboutUS.vue";
import Register from "@/views/Register.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";
import ProfileUser from "@/views/ProfileUser.vue";

import RegisterSeller from "@/views/RegisterSeller.vue";
import RegisterRider from "@/views/RegisterRider.vue";

import LoginAdmin from "@/components/Login/LoginAdmin.vue";
import AdminDashboard from "@/views/AdminDashboard.vue";
import AdminUserManagement from "@/views/AdminUserManagement.vue";
import AdminOrderManagement from "@/views/AdminOrderManagement.vue";
import AdminSellerManagement from "@/views/AdminSellerManagement.vue";
import AdminBoard from "@/views/AdminBoard.vue";
import AdminCategory from "@/views/AdminCategory.vue";
import AdminProduct from "@/views/AdminProduct.vue";
import AdminManagement from "@/views/AdminManagement.vue";
import AdminProfile from "@/views/AdminProfile.vue";
import AdminRiderManagement from "@/views/AdminRiderManagement.vue";
import AdminCommissions from "@/views/AdminCommissions.vue";
import AdminWithdrawals from "@/views/AdminWithdrawals.vue";
import AdminVehicleTypes from "@/views/AdminVehicleTypes.vue";
import AdminContactManagement from "@/views/AdminContactManagement.vue";
import AdminSettings from "@/views/AdminSettings.vue";
import AdminMonitoringMap from "@/views/AdminMonitoringMap.vue";
import SellerDashboard from "@/views/Seller/SellerDashboard.vue";
import SellerOrders from "@/views/Seller/SellerOrders.vue";
import SellerProducts from "@/views/Seller/SellerProducts.vue";
import SellerProductForm from "@/views/Seller/SellerProductForm.vue";
import SellerProfile from "@/views/Seller/SellerProfile.vue";
import SellerShippingConfig from "@/views/Seller/ShippingConfig.vue";

import RiderDashboard from "@/views/Rider/RiderDashboard.vue";
import RiderDeliveries from "@/views/Rider/RiderDeliveries.vue";
import RiderHistory from "@/views/Rider/RiderHistory.vue";
import RiderProfile from "@/views/Rider/RiderProfile.vue";

import ContactUs from "@/views/ContactUs.vue";
import Marketplace from "@/views/Marketplace.vue";
import PolicyPage from "@/views/PolicyPage.vue";
import Cart from "@/views/User/Cart.vue";
import Order from "@/views/User/Order.vue";
import CallRider from "@/views/User/CallRider.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/page_not_found",
    component: BlankLayout,
    children: [{ path: "", name: "PageNotFound", component: PageNotFound }],
  },
  {
    path: "/",
    component: DefaultLayout,
    children: [
      { path: "", name: "home", component: Home },
      { path: "aboutus", name: "aboutus", component: AboutUS },
      { path: "contactus", name: "contactus", component: ContactUs },
      { path: "terms", name: "terms", component: PolicyPage, meta: { policyType: "terms" } },
      { path: "privacy", name: "privacy", component: PolicyPage, meta: { policyType: "privacy" } },
      { path: "payment-terms", name: "payment_terms", component: PolicyPage, meta: { policyType: "payment" } },
      { path: "delivery", name: "delivery", component: Delivery },
      { path: "marketplace", name: "marketplace", component: Marketplace },
      {
        path: "product/:id",
        name: "product_detail",
        component: () => import("@/views/User/ProductDetail.vue")
      },
      { path: "board", name: "board", component: Board },
      { path: "board/list", name: "BoardList", component: BoardList },
      { path: "board/:boardId", name: "BoardDetail", component: BoardDetail },
      {
        path: "call-rider",
        name: "call_rider",
        component: CallRider,
        meta: { requiresAuth: true, authGroup: "user" },
      },
      {
        path: "cart",
        name: "cart",
        component: Cart,
        meta: { requiresAuth: true, authGroup: "user" },
      },
      {
        path: "order",
        name: "order",
        component: Order,
        meta: { requiresAuth: true, authGroup: "user" },
      },
      {
        path: "payment/qr/:orderId",
        name: "qr-payment",
        component: () => import("@/views/User/QRPayment.vue"),
        meta: { requiresAuth: true, authGroup: "user" },
      },
      {
        path: "payment/qr-topup/:transactionId",
        name: "qr-topup-payment",
        component: () => import("@/views/User/QRTopupPayment.vue"),
        meta: { requiresAuth: true, authGroup: "user" },
      },
      {
        path: "payment/success/:orderId",
        name: "payment-success",
        component: () => import("@/views/User/PaymentSuccess.vue"),
        meta: { requiresAuth: true, authGroup: "user" },
      },
      {
        path: "profile_user",
        name: "profile_user",
        component: ProfileUser,
        meta: { requiresAuth: true, authGroup: "user" },
      },
      {
        path: "profile/order/:id",
        name: "order-detail",
        component: () => import("@/components/ProfileUser/OrderDetail.vue"),
        meta: { requiresAuth: true, authGroup: "user" },
      },
      {
        path: "profile/travel/:id",
        name: "travel_detail",
        component: () => import("@/views/User/TravelDetail.vue"),
        meta: { requiresAuth: true, authGroup: "user" },
      },
      {
        path: "payment/travel-qr/:travelId",
        name: "travel-qr-payment",
        component: () => import("@/views/User/QRPaymentTravel.vue"),
        meta: { requiresAuth: true, authGroup: "user" },
      },
      {
        path: "shop/:sellerId",
        name: "shop",
        component: () => import("@/views/User/Shop.vue"),
      },
      {
        path: "products",
        name: "all_products",
        component: () => import("@/views/User/AllProducts.vue"),
      },
    ],
  },
  {
    path: "/information",
    component: DefaultNavbarLogin,
    children: [
      { path: "login", name: "login", component: Login, alias: "/login" },
      {
        path: "login/seller",
        name: "login_seller",
        component: Login,
        alias: "/login/seller",
        meta: { authGroup: "seller" },
      },
      {
        path: "login/rider",
        name: "login_rider",
        component: Login,
        alias: "/login/rider",
        meta: { authGroup: "rider" },
      },
      {
        path: "register",
        name: "register",
        component: Register,
        alias: "/register",
      },
      {
        path: "forgotPassword",
        name: "forgotPassword",
        component: ForgotPassword,
        alias: "/forgotPassword",
      },
      {
        path: "register/seller",
        name: "register_seller",
        component: RegisterSeller,
        alias: "/register/seller",
        meta: { authGroup: "seller" },
      },
      {
        path: "register/rider",
        name: "register_rider",
        component: RegisterRider,
        alias: "/register/rider",
        meta: { authGroup: "rider" },
      },
    ],
  },
  {
    path: "/admin/login",
    component: DefaultAdminLogin,
    children: [
      {
        path: "login_admin",
        name: "login_admin",
        component: LoginAdmin,
        meta: { authGroup: "admin" },
      },
    ],
  },
  {
    path: "/admin",
    component: DefaultAdmin,
    redirect: "/admin/dashboard",
    meta: {
      requiresAuth: true,
      authGroup: "admin",
      roles: ["admin", "superadmin"],
    },
    children: [
      {
        path: "dashboard",
        name: "admin_dashboard",
        component: AdminDashboard,
      },
      {
        path: "users",
        name: "admin_users",
        component: AdminUserManagement,
      },
      {
        path: "orders",
        name: "admin_orders",
        component: AdminOrderManagement,
      },
      {
        path: "sellers",
        name: "admin_sellers",
        component: AdminSellerManagement,
      },
      {
        path: "riders",
        name: "admin_riders",
        component: AdminRiderManagement,
      },
      {
        path: "riders/:riderId",
        name: "admin_rider_detail",
        component: () => import("@/views/AdminRiderDetail.vue"),
      },
      {
        path: "boards",
        name: "admin_boards",
        component: AdminBoard,
      },
      {
        path: "shipping-companies",
        name: "admin_vehicle_types",
        component: AdminVehicleTypes,
      },
      {
        path: "categories",
        name: "admin_category",
        component: AdminCategory,
      },
      {
        path: "products",
        name: "admin_product",
        component: AdminProduct,
      },
      {
        path: "admins",
        name: "admin_admins",
        component: AdminManagement,
      },
      {
        path: "profile",
        name: "admin_profile",
        component: AdminProfile,
      },
      {
        path: "commissions",
        name: "admin_commissions",
        component: AdminCommissions,
      },
      {
        path: "commission-simulator",
        name: "admin_commission_simulator",
        component: () => import("@/views/AdminCommissionSimulator.vue"),
      },
      {
        path: "commission-network",
        name: "admin_commission_network",
        component: () => import("@/views/AdminCommissionNetwork.vue"),
      },
      {
        path: "withdrawals",
        name: "admin_withdrawals",
        component: AdminWithdrawals,
      },
      {
        path: "tickets",
        name: "admin_tickets",
        component: () => import("@/views/AdminTickets.vue"),
      },
      {
        path: "tickets/:id",
        name: "admin_ticket_detail",
        component: () => import("@/views/AdminTicketDetail.vue"),
      },
      {
        path: "settings",
        name: "admin_settings",
        component: AdminSettings,
      },
      {
        path: "rider-service-config",
        name: "admin_rider_service_config",
        component: () => import("@/views/AdminRiderServiceConfig.vue"),
      },
      {
        path: "penalty-setting",
        name: "admin_penalty_setting",
        component: () => import("@/views/AdminPenaltySetting.vue"),
      },
      {
        path: "monitor-locations",
        name: "admin_monitor_locations",
        component: AdminMonitoringMap,
      },
      {
        path: "policies",
        name: "admin_policies",
        component: () => import("@/views/AdminPolicy.vue"),
      },
      {
        path: "contacts",
        name: "admin_contacts",
        component: AdminContactManagement,
      },
    ],
  },
  {
    path: "/seller",
    component: DefaultSeller,
    redirect: "/seller/dashboard",
    meta: {
      requiresAuth: true,
      authGroup: "seller",
      roles: ["seller", "sellerAdmin"],
    },
    children: [
      {
        path: "dashboard",
        name: "seller_dashboard",
        component: SellerDashboard,
      },
      {
        path: "orders",
        name: "seller_orders",
        component: SellerOrders,
      },
      {
        path: "orders/:id",
        name: "seller_order_detail",
        component: () => import("@/views/Seller/SellerOrderDetail.vue"),
      },
      {
        path: "products",
        name: "seller_products",
        component: SellerProducts,
      },
      {
        path: "products/add",
        name: "seller_product_add",
        component: SellerProductForm,
      },
      {
        path: "products/edit/:id",
        name: "seller_product_edit",
        component: SellerProductForm,
      },
      {
        path: "profile",
        name: "seller_profile",
        component: SellerProfile,
      },
      {
        path: "tickets",
        name: "seller_tickets",
        component: () => import("@/views/Seller/SellerTickets.vue"),
      },
      {
        path: "tickets/create",
        name: "seller_ticket_create",
        component: () => import("@/views/Seller/SellerTicketCreate.vue"),
      },
      {
        path: "tickets/:id",
        name: "seller_ticket_detail",
        component: () => import("@/views/Seller/SellerTicketDetail.vue"),
      },
      {
        path: "chat",
        name: "seller_chat",
        component: () => import("@/views/Seller/SellerChat.vue"),
      },
      {
        path: "shipping-config",
        name: "seller_shipping_config",
        component: SellerShippingConfig,
      },
      {
        path: "wallet",
        name: "seller_wallet",
        component: () => import("@/views/Seller/SellerWallet.vue"),
      },
    ],
  },
  {
    path: "/rider",
    component: DefaultRider,
    redirect: "/rider/dashboard",
    meta: {
      requiresAuth: true,
      authGroup: "rider",
      roles: ["rider"],
    },
    children: [
      {
        path: "dashboard",
        name: "rider_dashboard",
        component: RiderDashboard,
      },
      {
        path: "deliveries",
        name: "rider_deliveries",
        component: RiderDeliveries,
      },
      {
        path: "orders/:id",
        name: "rider_order_detail",
        component: () => import("@/views/Rider/RiderOrderDetail.vue"),
      },
      {
        path: "travels/:id",
        name: "rider_travel_detail",
        component: () => import("@/views/Rider/RiderTravelDetail.vue"),
      },
      {
        path: "history",
        name: "rider_history",
        component: RiderHistory,
      },

      {
        path: "profile",
        name: "rider_profile",
        component: RiderProfile,
      },
      {
        path: "tickets",
        name: "rider_tickets",
        component: () => import("@/views/Rider/RiderTickets.vue"),
      },
      {
        path: "tickets/create",
        name: "rider_ticket_create",
        component: () => import("@/views/Rider/RiderTicketCreate.vue"),
      },
      {
        path: "tickets/:id",
        name: "rider_ticket_detail",
        component: () => import("@/views/Rider/RiderTicketDetail.vue"),
      },
      {
        path: "wallet",
        name: "rider_wallet",
        component: () => import("@/views/Rider/RiderWallet.vue"),
      },
    ],
  },
  { path: "*", redirect: "/page_not_found" },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 }),
});

router.beforeEach((to, from, next) => {
  const store = router.app && router.app.$store;

  const authGroup =
    to.matched.find((r) => r.meta && r.meta.authGroup)?.meta.authGroup ||
    "user";

  const TOKEN_KEYS = {
    user: "user_token",
    seller: "seller_token",
    admin: "admin_token",
    rider: "rider_token",
  };

  const ROLE_KEYS = {
    user: "user_role",
    seller: "seller_role",
    admin: "admin_role",
    rider: "rider_role",
  };

  const LOGIN_ROUTE = {
    user: "login",
    seller: "login_seller",
    admin: "login_admin",
    rider: "login_rider",
  };

  const tokenKey = TOKEN_KEYS[authGroup] || "user_token";
  const roleKey = ROLE_KEYS[authGroup] || "user_role";
  const loginRouteName = LOGIN_ROUTE[authGroup] || "login";

  let token = localStorage.getItem(tokenKey);
  let role = localStorage.getItem(roleKey) || "user";

  let isTokenExpired = false;

  if (token) {
    try {
      const payloadBase64 = token.split(".")[1];
      const payload = JSON.parse(atob(payloadBase64));

      if (payload.exp) {
        const nowInSeconds = Date.now() / 1000;
        if (payload.exp < nowInSeconds) {
          isTokenExpired = true;
        }
      }
    } catch (e) {
      isTokenExpired = true;
    }
  }

  if (token && isTokenExpired) {
    if (store && store.dispatch) {
      try {
        store.dispatch("forceLogout", { authGroup });
      } catch (e) {
        store.dispatch("forceLogout").catch(() => { });
      }
    }

    try {
      localStorage.removeItem(tokenKey);
      localStorage.removeItem(roleKey);
    } catch (e) {
      console.error("Error removing token:", e);
    }

    if (to.name !== loginRouteName) {
      return next({
        name: loginRouteName,
        query: {
          reason: "session_expired",
        },
      });
    }

    return next();
  }

  if (store && token && !isTokenExpired) {
    try {
      store.commit("SET_AUTH", {
        access_token: token,
        login_by: authGroup + "_token",
      });
    } catch (e) {
      // ignore
    }
  } else if (store && !token) {
    try {
      store.commit("CLEAR_SESSION");
    } catch (e) {
      // ignore
    }
  }

  const isLoggedIn = !!token;
  const requiresAuth = to.matched.some((r) => r.meta && r.meta.requiresAuth);
  const allowedRoles = to.matched
    .filter((r) => r.meta && r.meta.roles)
    .flatMap((r) => r.meta.roles);

  if (requiresAuth && !isLoggedIn) {
    return next({
      name: loginRouteName,
      query: { redirect: to.fullPath },
    });
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return next({ name: "PageNotFound" });
  }

  return next();
});

router.afterEach((to) => {
  const authGroup = to.matched.find((r) => r.meta && r.meta.authGroup)?.meta.authGroup || "user";
  const baseTitle = "ELSONIII";
  const titles = {
    seller: `${baseTitle} - Seller`,
    admin: `${baseTitle} - Admin`,
    user: baseTitle,
    rider: `${baseTitle} - Rider`,
  };
  document.title = titles[authGroup] || titles.user;
});

export default router;
